module.exports = __webpack_public_path__ + "img/icon_ipo_suggestion_2@3x.17491a58.png";